import { Button } from '@approvalmax/ui';
import { Box } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { LineItemsGroupEdit } from 'pages/requestForm/components';
import { FC, memo } from 'react';
import { netSuiteExpenseLinesState } from 'shared/states';

import { SectionContainer } from '../../../../../components/SectionContainer';
import {
    GroupActions,
    SectionHeader,
    StyledLineItemsTable,
} from '../../../NetSuiteRequestForm/NetSuiteRequestForm.styles';
import { useExpenseReportExpenseLines } from '../../hooks';
import { useExpenseLines } from './ExpenseLines.hooks';
import { messages } from './ExpenseLines.messages';
import { ExpenseLinesProps } from './ExpenseLines.types';

/**
 * @deprecated Use {@link ExpenseSection} instead of this component
 */
export const ExpenseLines: FC<ExpenseLinesProps> = memo((props) => {
    const { workflowId, currency, requestDate, requestId, requestAttachments } = props;

    const expenseLines = useAtomValue(netSuiteExpenseLinesState);

    const { onAddLine, onRemoveLine, onCloneLine, onReorder } = useExpenseReportExpenseLines();

    const {
        columnsDefinition,
        isShowGroupButtons,
        isGroupCloneVisible,
        isGroupEditVisible,
        isGroupRemoveVisible,
        isGroupEditPopupVisible,
        groupItems,
        openGroupEdit,
        handleGroupClone,
        handleGroupRemove,
        closeGroupEdit,
    } = useExpenseLines({
        workflowId,
        currency,
        requestId,
        requestAttachments,
        requestDate: requestDate ?? null,
    });

    return (
        <SectionContainer
            title={
                <SectionHeader>
                    <Box spacing='0 20'>{messages.sectionName}</Box>

                    {isShowGroupButtons && (
                        <GroupActions>
                            {isGroupEditVisible && (
                                <Button preset='small' execute={openGroupEdit}>
                                    {messages.groupEdit}
                                </Button>
                            )}

                            {isGroupCloneVisible && (
                                <Button preset='small' execute={handleGroupClone}>
                                    {messages.groupClone}
                                </Button>
                            )}

                            {isGroupRemoveVisible && (
                                <Button preset='small' execute={handleGroupRemove}>
                                    {messages.groupRemove}
                                </Button>
                            )}
                        </GroupActions>
                    )}
                </SectionHeader>
            }
            noPadding
        >
            <StyledLineItemsTable
                columnDefinitions={columnsDefinition}
                lineItems={expenseLines}
                invalid={false}
                onAddLine={onAddLine}
                onRemoveLine={onRemoveLine}
                onCloneLine={onCloneLine}
                onReorder={onReorder}
                canAddLine={true}
            />

            {isGroupEditPopupVisible && <LineItemsGroupEdit onClose={closeGroupEdit} items={groupItems} />}
        </SectionContainer>
    );
});

ExpenseLines.displayName = 'ExpenseLines';
